import View from './View.js';
import previewView from './previewView.js';

class ResultView extends View {
  _parentElemnt = document.querySelector('.results');
  _erroMessage = 'אין תוצאות:)';
  _message = '';

  _generateMarkup() {
    console.log(this._data);
    //  return this._data.map(result => previewView.render(result, false)).join('');
   return previewView.render(this._data, false)
    //   return this._data
  }
}

export default new ResultView();
